/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import { Typography } from 'antd';
import isNil from 'lodash/isNil';

import s from './styles.module.less';

const Title = ({ className, children, note, ...props }) => (
  <Typography.Title className={clsx(s.title, className)} {...props}>
    {children}
    {!isNil(note) && <span className={s.titleNote}>{note}</span>}
  </Typography.Title>
);

export default Title;
